module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABVUlEQVQ4T+1VwVWDQBCd2QNw0xbsQCuQdGAHhgsLJ2MFiR3giR0u0Q7sQKxAOjAlJDfgsOMbXuIDhATf86Zz2t2Z/TvzmT8gDNh6vT6v63rJzJdDfgDYuK57HwTBtu/HoQtEtACAFQAUI4DyUKK1lpiOYZZl4jxrnzJzIntEFOBvdsS/QyKStDuAI1lNOd6h8FWWZcOVUuoVAJ6ttU9Tbiul5gBwa62dSbzneUWHQyJiAHgY4maEa+FwqbX+whkFlMwPX1HWAtjey5qIpgFKyUqpDykljuPcGPMigFEU3aRp6gs11tqLfcmnM7TW5vtLDSAR5QKotfZbgDOllD+p5H/AP8Jh04eIeBWGYSF9iIhbrfVchgkzv/+oD39Vesz8GEXR4Njq69kYkyDi3TEtiyKumblRxilDRFHKmyjoENsZDjIEqqpaIeLY6O+/sXEcZ9H+FXwCfthWyhR0ISIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/pubmedSearch/del.png
// module id = H2Ab
// module chunks = 1